module.exports = __webpack_public_path__ + "img/login-bg.2403bc5.png";